import { useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

interface RouterResult {
  go: (path: string, state?: Record<string, unknown>) => void;
  back: () => void;
  params: Record<string, string>;
  location: ReturnType<typeof useLocation>;
  query: URLSearchParams;
}

export function useRouter(): RouterResult {
  const navigate = useNavigate();
  const params = useParams<Record<string, string>>();
  const location = useLocation();

  const go = useCallback((path: string, state?: Record<string, unknown>) => navigate(path, { state }), [navigate]);
  const back = useCallback(() => navigate(-1), [navigate]);

  return {
    go,
    back,
    params: (params ?? {}) as Record<string, string>,
    location,
    query: new URLSearchParams(location.search),
  };
}
